import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Spinner } from 'react-bootstrap';
import Layout from '../NewHeader/Layout';
import './deliverychart.css';
import slotimg from "../../images/shawarma/sh1.png";
import slotimg1 from "../../images/sandwich/s2.png";
import slotimg2 from "../../images/lunch/lunch3.png";
import axios from 'axios';
import { var_api, image_api } from '../constant';
import { useHistory } from 'react-router-dom';

const DeliveryChart = () => {
  const [loading, setLoading] = useState(false);
  const [startDate] = useState(new Date());
  const [dates, setDates] = useState([]);
  const [slots] = useState(['Breakfast', 'Lunch', 'Dinner']);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedSlotDetails, setSelectedSlotDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [itempopup, setItempopup] = useState(false);
  const [slotList, setSlotList] = useState([]);
  const [slotOrders, setSlotOrders] = useState([]);
  const [slotItems, setSlotItems] = useState([]);
  const [slotDetail, setSlotDetail] = useState(null);
  const [selecetedDate, setSelectedDate] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const formatDate = (date) => {
      return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    };

    const generatedDates = Array.from({ length: 7 }, (_, index) => {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + index);
      return formatDate(date);
    });
    setDates(generatedDates);

    setLoading(true);
    setTimeout(() => {
      const bookedData = generatedDates.map(date => {
        return slots.reduce((acc, slot) => {
          acc[slot] = Math.floor(Math.random() * 20);
          return acc;
        }, {});
      });
      setData(bookedData);
      setLoading(false);
    }, 1000);
  }, [startDate, slots]);


  useEffect(() => {
    fetchSlots();
  },[]);

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleItempopup = (items) => { 
    setSlotItems(items);
    setItempopup(true);
  };

  const itemsList = [
    { name: "Item 1", qty: 2, unitPrice: 100, image: slotimg },
    { name: "Item 2", qty: 5, unitPrice: 200, image: slotimg1 },
    { name: "Item 3", qty: 1, unitPrice: 150, image: slotimg2 },
  ];

  const handleSlotClick = (slot_id, date, slot) => {
    // const slotDetails = [
    //   { sNo: 1, customerName: 'John Doe', mobile: '123-456-7890', orderId: 'A123', customerAddress: '123 Main St', deliveryDate: '08/11/2024', totalAmount: '$50', slotType: slot, orderType: 'Online', status: 'Delivered' },
    //   { sNo: 2, customerName: 'Jane Smith', mobile: '987-654-3210', orderId: 'B456', customerAddress: '456 Elm St', deliveryDate: '08/11/2024', totalAmount: '$30', slotType: slot, orderType: 'Offline', status: 'Pending' },
    // ];
    // setSelectedSlotDetails(slotDetails);
    fetchSlotsOrders(slot_id, date);
    setShow(true);
    setSlotDetail(slot);
    setSelectedDate(date);
    console.log("datae", slot_id, date);
  };


  //fetch slot list
  const fetchSlots = async () => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}slot-master/get-active/${shop_id}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response);
      const user = response.data;
      setSlotList(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };


  const fetchSlotsOrders = async (slot_id, date) => {
    setLoading(true);
    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
  
    try {
      const response = await axios.get(
        `${var_api}booking-orders/delivery-chart-slots/${shop_id}/${slot_id}/${date}`,
        {
          headers: {
            Authorization: `${token}`, // Add the token to the Authorization header dynamically
          },
        }
      );
      setLoading(false);
      console.log("Response received:", response.data.data);
      const user = response.data.data;
      setSlotOrders(user);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };

  const slotColors = {
    1: 'blue', // Replace 1, 2, 3 with your actual slot IDs
    2: 'violet',
    3: 'brown',
    4: 'orange', // Add more IDs and colors as needed
  };

  return (
    <Layout>
      <div className="splitpr">
        <div style={{ border: "none", padding: "20px", width: "100%", height: "auto", margin: "auto", borderRadius: "15px", backgroundColor: "white", boxShadow: "rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px" }}>
          <div className="row">
            <div className='col'>
            <h4 className='ushe'> DELIVERY CHART</h4>
            </div>
            <div className="col">
              {/* <input className="form-control" type="search" placeholder="Search" style={{ maxWidth: "230px", border: "1px solid black", float: "right" }} onChange={handleSearchInput} /> */}
            </div>
          </div>
          <div className="table-container" style={{ height: "500px", overflowX: 'auto', overflowY: 'scroll', marginTop: "5px" }}>
            <Table hover style={{ width: "95%", margin: "auto" }}>
              <thead>
                <tr>
                  <th rowSpan="2" style={{ textAlign: "center", verticalAlign: "middle" }}>Date</th>
                  {dates.map((date, index) => (
                    <th key={index} style={{ textAlign: "center" }}>{date}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={dates.length + 1} style={{ textAlign: "center" }}>
                      <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                    </td>
                  </tr>
                ) : (
                  slotList.map((slot, slotIndex) => (
                    <tr key={slotIndex}>
                      {/* Render the slot name only once using rowSpan */}
                      {slotIndex === 0 && (
                        <td rowSpan={slotList.length} style={{
                          textDecoration: "underline", 
                          textAlign: "center", 
                          fontWeight: "bold", 
                          verticalAlign: "middle", 
                          borderRight: "1px solid black", // Add right border
                          borderBottom: "1px solid black"  // Add bottom border
                        }}>
                          Slot
                        </td>
                      )}
                      {dates.map((date, dateIndex) => {
                         const color = slotColors[slotIndex+1] || 'black'; 
                  
                        return (
                          <td key={dateIndex} style={{ textAlign: "center" }}>
                            <span onClick={() => handleSlotClick(slot.id,date, slot)} style={{ cursor: "pointer", textDecoration: "underline", color }}>
                              <span style={{ fontSize: "14px" }}>{slot.slot_name}</span>{' '}
                              {/* <span style={{ fontSize: "17px", fontWeight: "bold" }}>{data[dateIndex]?.[slot.slot_name] ?? "N/A"}
                              </span> */}
                            </span>
                          </td>
                        );
                      })}
                    </tr>
                  ))
                  
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={() => setShow(false)} backdrop="static" keyboard={false} size="md">
        <Modal.Header closeButton style={{ backgroundColor: "rgba(6, 105, 16, 0.367)", padding: "22px" }} />
        <Modal.Body>
          <div style={{ padding: "20px" }}>
            <h4 style={{ fontFamily: "monospace", fontWeight: "bolder", textAlign: "center" }}>CONFIRM!</h4>
            <h6 className='text-dark' style={{ textAlign: "center", fontWeight: "bolder" }}>
              Are you sure you want to delete this blocked slot?
            </h6>
          </div>
          <Button variant="danger" style={{ float: "right" }} onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="success" style={{ float: "right", marginRight: "5px" }} onClick={() => setShow(false)}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>

      {/* Modal for Slot Details */}
      <Modal show={show} onHide={() => setShow(false)} size="xl" backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Slot Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="d-flex justify-content-center align-items-center m-3">
  {slotDetail && selecetedDate && (
    <div className="card shadow-sm" style={{ width: "auto", borderRadius: "12px", padding: "10px" }}>
      <div className="card-body d-flex justify-content-between align-items-center gap-5">
        <div>
          <h6 className="mb-0"><strong>Delivery Date:</strong> <span style={{color:"red"}}>{selecetedDate}</span></h6>
        </div>
        <div>
          <h6 className="mb-0"><strong>Slot Name:</strong> <span style={{color:"red"}}>{slotDetail.slot_name}</span></h6>
        </div>
        <div>
          <h6 className="mb-0"><strong>Slot Time:</strong> <span style={{color:"red"}}>{slotDetail.from_time} - {slotDetail.to_time}</span></h6>
        </div>
      </div>
    </div>
  )}
</div>


          <Table hover>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Order ID</th>
                <th>Customer Name</th>
                <th>Mobile</th>
                <th>Address</th>
                <th>Total Amount</th>
                <th>Order Type</th>
                <th>Delivery Person Name</th>
                <th>Delivery Time</th>
                <th>PickedUp Time</th>
                <th>Delivered Time</th>
                <th>Paid status</th>
                <th>Status</th>
                <th>Items</th>
              </tr>
            </thead>
            <tbody>
            {slotOrders.length > 0 ? (
              slotOrders.map((detail, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>{detail.order_no}</td>
                  <td>{detail.customer_name}</td>
                  <td>{detail.mobile_no}</td>
                  <td>{detail.delivery_address}</td>
                  <td>{detail.amount}</td>
                  <td>{detail.order_type == 1 ? "Normal Order" : detail.order_type == 2 ? "Credit Order" : "Pending"}</td>
                  <td>
                  {detail.booking_dates[0]?.slots[0]?.delivery_person_name  ? (
                    <>
                  {detail.booking_dates[0]?.slots[0]?.delivery_person_profile && (
        <img
          src={detail.booking_dates[0]?.slots[0]?.delivery_person_profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {detail.booking_dates[0]?.slots[0]?.delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
                  <td>{detail.booking_dates[0]?.slots[0]?.delivery_time}</td>
                  <td>{detail.booking_dates[0]?.slots[0]?.pickup_time}</td>
                  <td>{detail.booking_dates[0]?.slots[0]?.delivered_time}</td>
                  <td>{detail.payment_status == 1 ? "Paid" : "Not Paid"}</td>
                  <td style={{
          textAlign: "left",
          color: detail.booking_dates[0]?.slots[0]?.slot_status === 0 ? "blue" :
          detail.booking_dates[0]?.slots[0]?.slot_status === 1 ? "rgb(50, 184, 23)" :
          detail.booking_dates[0]?.slots[0]?.slot_status === 2 ? "rgb(184, 184, 2)" :
          detail.booking_dates[0]?.slots[0]?.slot_status === 3 ? "orange" : 
          detail.booking_dates[0]?.slots[0]?.slot_status === 4 ? "gray" : 
          detail.booking_dates[0]?.slots[0]?.slot_status === 5 ? "green" : 
          "red",
          fontWeight: "bold",
        }}>
          {detail.booking_dates[0]?.slots[0]?.slot_status === 0 ? "New" :
           detail.booking_dates[0]?.slots[0]?.slot_status === 1 ? "Order Accepted" :
           detail.booking_dates[0]?.slots[0]?.slot_status === 2 ? "Inprogress" :
           detail.booking_dates[0]?.slots[0]?.slot_status === 3 ? "Packed" :
           detail.booking_dates[0]?.slots[0]?.slot_status === 4 ? "Picked up" : 
           detail.booking_dates[0]?.slots[0]?.slot_status === 5 ? "Delivered" :
           "Cancelled"}
        </td>
        <td>
              <button className="btn btn-primary" onClick={() => handleItempopup(detail.booking_dates[0]?.slots[0]?.order_items)}>
                <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="14" style={{ textAlign: "center", color: "red" }}>
                  No data available
                </td>
              </tr>
            )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

       {/*item modal*/}
      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>
          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {slotItems.length > 0 ? (
          slotItems.map((item, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
              <td>{index + 1}</td>
              <td>
                <img
                  src={`${image_api}/${item.food_image}`}
                  alt="item_image"
                  width="50px"
                  height="50px"
                />
              </td>
              <td>{item.food_name}</td>
              <td>{item.item_code}</td>
              <td>{item.quantity}</td>
              <td>{item.unit_price}</td>
              <td>{item.variant_name}</td>
              <td>{item.remark}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
       </Table>
    <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ gfloat: "right", marginTop: "-1px" }}
    >
      Close
    </button>
  </Modal.Body>
</Modal>
      
    </Layout>
  );
};

export default DeliveryChart;
